import { SimplifiedPaginator } from '@app/classes/simplified-paginator';
import { TaxReturnSummary } from '@app/models/payroll/tax-return-summary.abstract.model';
import { Table } from '@table/classes/table.class';
import { MenuColumnItem } from '@table/interfaces/menu-column-item.interface';
import { of } from 'rxjs';
import {
    ActionButton,
    AgencyColumn,
    CompleteDateColumn,
    PackageColumn,
    StatusColumn,
    SubmitDateColumn,
} from './columns';

export { Event as ActionEvent } from './columns';
export type MenuEvent = 'delete' | 'preview' | 'view' | 'download';

const submittedRowOptions: MenuColumnItem<MenuEvent>[] = [
    {
        label: 'table.employeeTaxForms.viewDetails',
        event: 'view',
    },
    {
        label: 'table.employeeTaxForms.downloadTaxPackage',
        event: 'download',
    },
];

const openRowOptions: MenuColumnItem<MenuEvent>[] = [
    {
        label: 'table.employeeTaxForms.deleteTaxPackage',
        event: 'delete',
    },
    {
        label: 'table.employeeTaxForms.downloadPreview',
        event: 'preview',
    },
];

export class EmployerTaxPackagesTable extends Table<TaxReturnSummary> {
    showMenuColumnOptions = true;

    constructor(public summaries: TaxReturnSummary[]) {
        super();
        this.boot();
    }

    setColumns(): void {
        this.columns = [
            new PackageColumn(),
            new AgencyColumn(),
            new StatusColumn(),
            new SubmitDateColumn(),
            new CompleteDateColumn(),
            new ActionButton(),
        ];
    }

    setDataSource(): void {
        this.paginator = new SimplifiedPaginator(of(this.summaries));
    }

    getMenuColumnOptionsForRow(summary: TaxReturnSummary): MenuColumnItem<MenuEvent>[] {
        if (!summary.id) {
            return [];
        }

        return summary.isSubmitted ? submittedRowOptions : openRowOptions;
    }
}
